"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CircularProgress", {
  enumerable: true,
  get: function get() {
    return _CircularProgress.default;
  }
});
Object.defineProperty(exports, "LinearProgress", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _CircularProgress = _interopRequireDefault(require("./CircularProgress"));

var _LinearProgress = _interopRequireDefault(require("./LinearProgress"));


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Progress/index.js
// module id = 434
// module chunks = 52252321336229